import { Page } from '@/core/architecture'

import { ConsoleCampaignBannerSettingTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCampaignBannerSetting Page
 * Implemented as a practical sample.
 */
export const ConsoleCampaignBannerSetting: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCampaignBannerSettingTemplate state={state} {...actions} />
}
